export default __webpack_public_path__ + "static/media/helper.7932f770.svg";